import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TextAlignment } from '@y42/json-schema';

@Component({
  selector: 'y42-context-menu-alignment',
  templateUrl: './context-menu-alignment.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuAlignmentComponent {
  get icon(): IconProp {
    return this.alignment && this.textAlignments.includes(this.alignment)
      ? ['far', `align-${this.alignment}`]
      : ['far', 'align-left'];
  }

  @Input()
  alignment?: TextAlignment;

  @Output()
  alignmentChanged = new EventEmitter<TextAlignment>();

  // Allow accessing the TextAlignment in the template.
  readonly TextAlignment = TextAlignment;

  private readonly textAlignments: TextAlignment[] = [TextAlignment.Left, TextAlignment.Center, TextAlignment.Right];
}
